<template>
  <div class="container-fluid">
    <h3 class="mt-3 mb-3">খরচ বিবরণী</h3>
    <div class="row mb-3">
      <form onsubmit="return false" class="form-inline">
        <label>রিপোর্ট শুরুর তারিখ</label>
        <datepicker :highlighted="{ days: [5] }" input-class="form-control ml-2 mr-2" v-model="from" format="dd MMMM yyyy">
        </datepicker>
        হতে
        <datepicker :highlighted="{ days: [5] }" input-class="form-control ml-2 mr-2" v-model="to" format="dd MMMM yyyy">
        </datepicker>

        <label>পর্যন্ত</label>
        <button class="btn btn-primary ml-4" @click="getReportTraining">রিপোর্ট তৈরী করুন</button>
      </form>

    </div>
    <h3 class="mt-3">খরচ বিবরণী</h3>
    <table class="table">
      <thead>
      <tr>
        <th class="text-center">তারিখ</th>
        <th>পরিচিতি বিবরণ</th>
        <th>ঠিকানা</th>
        <th>মোবাইল</th>
        <th>ধরণ</th>
        <th class="text-right">টাকার পরিমান</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="i in expense" v-bind:key="i.info.id">
        <td class="bn-number text-center">{{ AmountService.toBanglaTextDate(i.date) }}</td>
        <td>{{ i.info.primaryName }} ({{i.info.secondaryName}})</td>
        <td>{{ i.info.address }}</td>
        <td>{{ i.info.mobile }}</td>
        <td>{{ i.type }}</td>
        <td class="bn-number text-right">{{ AmountService.commaDecimalWithCurrency(i.amount.toFixed(2)) }}</td>
      </tr>
      </tbody>
      <tfoot>
      <tr class="font-weight-bold">
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td><h4 class="font-weight-bold text-right">মোট খরচ</h4></td>
        <td class="bn-number text-right">{{ AmountService.commaDecimalWithCurrency(salesMot.toFixed(2))}}</td>
      </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import DateAdjust from "@/services/DateAdjust.js";
import Datepicker from 'vuejs-datepicker';
import AmountService from "@/services/amountService";
import IdentityType from "@/services/DataStructure/IdentityType";
export default {
  name: "ExpenseStatementComponent",
  components: { Datepicker },
  data() {
    return {
      expense: [],
      saleOut: [],
      salesMot:0.00,
      from: '',
      to: '',
    }
  },
  methods: {
    getFullDateToTimeStamp(fullDate) {
      let year = new Date(fullDate).getFullYear()
      let month = new Date(fullDate).getMonth() + 1
      if (month > 0 && month < 10) {
        month = "0" + month
      }
      let date = new Date(fullDate).getDate()
      if (date > 0 && date < 10) {
        date = "0" + date
      }
      let formattedDate = year + "-" + month + "-" + date + "T00:00:00Z"
      return new Date(formattedDate).getTime()
    },
    async getReportTraining() {
      let fromDate = this.getFullDateToTimeStamp(this.from);
      let toDate = this.getFullDateToTimeStamp(this.to);
      let transactions = await DateAdjust.printAllTrx();
      this.expense = transactions.filter(x => x.zz <= toDate && x.zz >= fromDate).filter(x => x.section === "expense" && x.type!= "stock");
      this.expense.map(x=>{
        x.type = this.getIdentityTranslation(x.info.type)
      })
      this.salesMot = this.expense.reduce((sum, x)=> sum+x.amount,0);
    },
    getIdentityTranslation(identityType){
      let identityName;
      switch (identityType) {
        case IdentityType.CUSTOMER:
          identityName = "কাস্টমার";
          break;
        case IdentityType.SUPPLIER:
          identityName = "সাপ্লাইয়ার";
          break;
        case IdentityType.VEHICLE:
          identityName = "ট্রাক";
          break;
        case IdentityType.CONTRACT:
          identityName = "ঠিকাদারী কাজ";
          break;
        case IdentityType.BANK:
          identityName = "ব্যাংক একাউন্ট";
          break;
        case IdentityType.THIRD_PARTY:
          identityName = "থার্ড পার্টি";
          break;
        case IdentityType.HARVEST:
          identityName = "ফসল";
          break;
        case IdentityType.EXPENSE:
          identityName = "খরচ";
          break;
        case IdentityType.DRAWING:
          identityName = "উত্তোলন";
          break;
        case IdentityType.PROFIT:
          identityName = "লভ্যাংশ";
          break;
      }
      console.log(identityName)
      return identityName;
    }
  },
  computed: {
    AmountService() {
      return AmountService
    }
  }
}
</script>

<style scoped></style>